import axios from 'axios'
import cookie from '@/common/utils/cookie'
import { comparePath, getService, getServiceLocationInfo, isExplorer } from '@/common/utils/common'
import _ from 'lodash'
import fp from 'lodash/fp'
import { SERVICE_LOCATION_AMAZON, SERVICE_LOCATION_AZURE } from '@/common/resources/const'
import { parseUrl, stringify } from 'query-string'
import {
  API_BASE_ANNEX_AZURE_URL,
  API_BASE_ANNEX_URL,
  API_BASE_ANNEXM_AZURE_URL,
  API_BASE_ANNEXM_URL,
  API_BASE_AZURE_URL,
  API_BASE_URL,
  API_BASE_URL_CLOVER_FIELD,
  AWS_WHITE_LIST,
  HTTP_METHOD_DELETE, HTTP_METHOD_GET,
  HTTP_METHOD_POST, URL_GET_URL_FROM_UI_CODE
} from '@/common/utils/request.const'
import { eventBodyListParser, getSectionEventObject } from '@/common/utils/gnb.fp'
import utils from '@/common/util/utils'

export const API_KEY = 'E5F3E0D30947AA5440556471321BB6D9'

/**
 * API 공통 파라미터 정의
 * 주의::getCommonParam가 api.service.js에도 있음(왠만하여 여기껄 사용)
 * TODO:: @/common/util/utils를 사용하지 않으려 했으나 가져올 함수가 많아서 차후 util/을 정리할때 같이 정리
 * @returns {{apikey: string, partner: string, region: string, device: *, targetage: (string|*|number), drm: *, pooqzone: (string|*)}}
 */
export const getCommonParam = () => {
  return {
    apikey: API_KEY,
    device: utils.cookies.getDevice(),
    partner: 'pooq',
    pooqzone: utils.cookies.getDevice() === 'mobile' ? 'none' : utils.cookies.getPooqZone(),
    region: 'kor',
    drm: utils.cookies.getDrm(),
    targetage: utils.cookies.getTargetAge(),
    service: getService()
  }
}
export const getCredential = () => {
  return {
    credential: encodeURIComponent(cookie.getCredential())
  }
}

export const makeRequest = (req) => {
  const requestInfo = {
    url: req.url,
    method: req.method,
    responseType: 'json',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8'
    }
  }

  // INFO: Support Azure migration
  const { url } = parseUrl(requestInfo.url)
  const locationInfo = getServiceLocationInfo()
  const locationType = _.get(locationInfo, 'location', SERVICE_LOCATION_AMAZON)
  const isAnnexAPI = url.indexOf(API_BASE_ANNEX_URL) > -1
  const isAnnexmAPI = url.indexOf(API_BASE_ANNEXM_URL) > -1
  if (locationType === SERVICE_LOCATION_AZURE) {
    const isUiEventAPI = url.indexOf('uievent3.') > -1
    if (isAnnexAPI || isAnnexmAPI) {
      if (isAnnexAPI) {
        requestInfo.url = requestInfo.url.replace(API_BASE_ANNEX_URL, API_BASE_ANNEX_AZURE_URL)
      } else {
        requestInfo.url = requestInfo.url.replace(API_BASE_ANNEXM_URL, API_BASE_ANNEXM_AZURE_URL)
      }
    } else if (isUiEventAPI) {
      requestInfo.url = requestInfo.url.replace('uievent3.pooq.co.kr', 'uievent3.wavve.com')
    } else {
      const targetUrl = url.replace(API_BASE_URL_CLOVER_FIELD, '').replace(API_BASE_URL, '')
      const forceAWS = AWS_WHITE_LIST.find((checkPath) => {
        return checkPath.method === requestInfo.method && comparePath(checkPath.path, targetUrl)
      }) !== undefined
      if (!forceAWS) {
        requestInfo.url = requestInfo.url.replace(API_BASE_URL, API_BASE_AZURE_URL)
      }
    }
  }

  // Support Azure migration end
  if (req.headers) {
    requestInfo.headers = _.assign(requestInfo.headers, req.headers)
  }
  requestInfo.params = getCommonParam()
  const credentialInParameters = _.get(requestInfo, 'params.credential', '')
  if (credentialInParameters === '') {
    requestInfo.params = _.assign({}, requestInfo.params, getCredential())
    const isHaystackDomain = url.indexOf('haystack.wavve.com') > -1
    const isAnnexDomain = url.indexOf('annexm') > -1 || url.indexOf('annexapi') > -1
    if (!isAnnexDomain && !isHaystackDomain) {
      let credential = cookie.getCredential()
      if (_.get(req, 'url', '').indexOf('credential') > -1) {
        const { query } = parseUrl(_.get(req, 'url', ''))
        credential = query['credential']
      }
      requestInfo.headers = _.assign({}, requestInfo.headers, { 'wavve-credential': credential })
    }
  }
  requestInfo.paramsSerializer = (params) => {
    return stringify(params, { encode: false })
  }
  if (req.method === HTTP_METHOD_POST || req.method === HTTP_METHOD_DELETE) {
    requestInfo.data = req.data
    requestInfo.transformRequest = (data, headers) => {
      return JSON.stringify(data)
    }
  }
  return requestInfo
}

export const apiRequest = (req) => {
  return axios(makeRequest(req))
}

export const applyQueryString = (url, queryString) => `${url}?${stringify(queryString)}`
export const applyPath = (url, path) => `${url}/${path}`

const isUiEventPath = url => url.indexOf('uievent') > -1
export const fetchFromEventObject = (eventData) => {
  const reqObj = {
    url: `https://${_.get(eventData, 'url')}`,
    method: _.get(eventData, 'method', HTTP_METHOD_GET)
  }
  if (reqObj.method === HTTP_METHOD_DELETE || reqObj.method === HTTP_METHOD_POST) {
    const parsedEventData = eventBodyListParser(eventData)
    reqObj.data = isUiEventPath(reqObj.url) ? { list: [parsedEventData] } : parsedEventData
  }
  return apiRequest(reqObj)
}

export const fetchOnContent = (sectionInfo) => {
  const { onContent } = fp.flow(
    fp.getOr([], 'eventlist'),
    getSectionEventObject
  )(sectionInfo)
  return fetchOnEventObject(onContent)
}

export const fetchOnViewMore = (sectionInfo) => {
  const { onViewMore } = fp.flow(
    fp.getOr([], 'eventlist'),
    getSectionEventObject
  )(sectionInfo)
  return fetchOnEventObject(onViewMore)
}

export function fetchOnEventObject (onEvent) {
  const requestUrl = _.get(onEvent, 'url')
  const { url, query } = parseUrl(requestUrl)
  const keywordInQuery = _.get(query, 'keyword', '')
  if (isExplorer() && keywordInQuery !== '') {
    query.keyword = decodeURIComponent(query.keyword)
    onEvent.url = url + '?' + stringify(query)
  }
  return fetchFromEventObject(onEvent)
}

export const getUrlFromUiCode = (uiCode) => {
  return apiRequest(
    {
      url: applyPath(URL_GET_URL_FROM_UI_CODE, uiCode),
      method: HTTP_METHOD_GET
    })
}
